import styled from 'styled-components';
import {
  borderRadius,
  borderColor,
  color,
  BorderRadiusProps,
  BorderColorProps,
  ColorProps,
} from 'styled-system';

export const Container = styled.div<
  BorderRadiusProps & ColorProps & BorderColorProps
>`
  display: inline-flex;
  align-items: center;

  ${color};
  ${borderColor};
  ${borderRadius};

  box-shadow: 0px 2px 4px rgba(2, 11, 17, 0.15);
  box-sizing: border-box;

  border-width: 1px;
  border-style: solid;

  width: 100%;
  height: 34px;
  overflow: hidden;

  iframe {
    width: 100% !important;
    height: 34px !important;
  }
`;
